(() => {
  function initAll() {
    subSliderInit(true);
    sliderInit(true);
    popupSliderInit(true);
    initJudgeMeReviewsCount();
  }

  function slideUp(el, duration) {
    const height = el.clientHeight;
    el.style.transitionProperty = 'height, margin, padding';
    el.style.transitionDuration = duration + 'ms';
    el.style.boxSizing = 'border-box';
    el.style.overflow = 'hidden';
    el.style.height = height + 'px';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';

    setTimeout(() => {
      el.style.height = '0';
      el.style.paddingTop = '0';
      el.style.paddingBottom = '0';
      el.style.marginTop = '0';
      el.style.marginBottom = '0';
    }, 10);

    setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
    }, duration);
  }

  const initAccordion = (root) => {
    if (!root) return;
    const selector = root.closest('.product__main-dropdowns')
      ? '.product__main [data-accordion-toggle]'
      : '.product__info-container [data-accordion-toggle]';

    root.querySelectorAll('[data-accordion-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        root.querySelectorAll(selector).forEach((el) => {
          if (el !== toggle) {
            el.classList.remove('active');
            slideUp(el.nextElementSibling, 300);
          }
        });

        if (toggle.classList.contains('active')) {
          toggle.classList.remove('active');
          slideUp(toggle.nextElementSibling, 300);
        } else {
          toggle.classList.add('active');
          const panel = toggle.nextElementSibling;
          panel.style.overflow = 'hidden';
          panel.style.height = '0';
          panel.style.display = 'block';
          const fullHeight = panel.scrollHeight;
          setTimeout(() => (panel.style.height = fullHeight + 'px'), 10);
          setTimeout(() => {
            panel.style.removeProperty('overflow');
            panel.style.removeProperty('height');
          }, 300);
        }
      });
    });
    root.querySelectorAll('[data-accordion-close]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        root.querySelectorAll(selector).forEach((el) => {
          if (el !== toggle) {
            el.classList.remove('active');
            slideUp(el.nextElementSibling, 300);
          }
        });

        if (toggle.classList.contains('active')) {
          toggle.classList.remove('active');
          slideUp(toggle.nextElementSibling, 300);
        }
      });
    });
  };

  const initStickyButtons = () => {
    const wrapper = document.querySelector('.main-product .product-form__submit-wrapper');
    if (!wrapper) return;

    let atTop = true,
      atBottom = false;

    const update = () => {
      if (atTop || atBottom) {
        wrapper.closest('.product-form__buttons-row').removeAttribute('style');
        wrapper.classList.remove('fixed');
      } else if (!wrapper.classList.contains('fixed')) {
        wrapper.closest('.product-form__buttons-row').style.minHeight = wrapper.clientHeight + 'px';
        wrapper.classList.add('fixed');
      }
    };

    new IntersectionObserver(
      ([e]) => {
        atTop = e.isIntersecting;
        update();
      },
      { root: null, rootMargin: '0px 0px 45px 0px', threshold: 0.01 }
    ).observe(document.querySelector('.product-form__buttons'));

    const footerEl = document.querySelector('.footer');
    if (footerEl) {
      new IntersectionObserver(
        ([e]) => {
          atBottom = e.isIntersecting;
          update();
        },
        { root: null, rootMargin: '0px', threshold: 0.01 }
      ).observe(footerEl);
    }
  };

  class ProductModal extends ModalDialog {
    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(trigger) {
      super.show(trigger);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const id = this.openedBy.getAttribute('data-media-id');
      const mediaEl = this.querySelector(`[data-media-id="${id}"]`);
      if (
        mediaEl?.nodeName === 'DEFERRED-MEDIA' &&
        mediaEl.querySelector('template')?.content.querySelector('.js-youtube')
      ) {
        mediaEl.loadContent();
      }
    }
  }

  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  const compareBadge = async (shopDomain, publicApiToken) => {
    try {
      const [countRes, ratingRes] = await Promise.allSettled([
        fetch(`https://judge.me/api/v1/widgets/all_reviews_count?shop_domain=${shopDomain}&api_token=${publicApiToken}`),
        fetch(`https://judge.me/api/v1/widgets/all_reviews_rating?shop_domain=${shopDomain}&api_token=${publicApiToken}`)
      ]);

      const count = countRes.status === 'fulfilled' && countRes.value.ok ? (await countRes.value.json()).all_reviews_count : null;
      const rating = ratingRes.status === 'fulfilled' && ratingRes.value.ok ? (await ratingRes.value.json()).all_reviews_rating : null;

      return count || rating ? `${rating ? `(${rating}) ` : ''}${count || ''} reviews` : null;
    } catch (error) {
      console.error('Error fetching Judge.me data:', error);
      return null;
    }
  };

  const initJudgeMeReviewsCount = () => {
    window.jdgm.docReady(async () => {
      const shopDomain = window.Shopify?.shop || document.querySelector('meta[property="og:url"]')?.content?.replace(/^https?:\/\//, '').replace(/\/.*$/, '');
      const publicApiToken = window.judgeMeSettings?.publicApiToken || document.querySelector('meta[name="judgeme_public_api_token"]')?.content;

      if (!shopDomain || !publicApiToken) return;

      const container = document.querySelector('.jdgm-prev-badge');
      const oldElement = container?.querySelector('.jdgm-prev-badge__text');
      if (!oldElement) return;

      oldElement.style.display = 'none';
      const badge = await compareBadge(shopDomain, publicApiToken);

      console.log('badge', badge);

      if (badge && badge !== 'Reviews') {
        const newElement = document.createElement('span');
        newElement.className = 'jdgm-prev-badge__text-custom';
        newElement.textContent = badge;
        container.appendChild(newElement);
      } else {
        oldElement.style.display = '';
      }
    });
  };

  document.addEventListener('shopify:section:load', (e) => {
    initAccordion(e.target);
    initStickyButtons();
    initAll();
  });

  initAll();
  initAccordion(document.currentScript.parentElement);
  initStickyButtons();
})();
